import { render, staticRenderFns } from "./cElements.vue?vue&type=template&id=8e504832&"
import script from "./cElements.vue?vue&type=script&lang=js&"
export * from "./cElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports